export const blockIconsCommonactionsLockOpenNew = (
	<span className='material-symbols-outlined'>lock_open</span>
);
